import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const inventoryitemService = {

  /** GET - All items with filters */
  getAll: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.GET_ALL,
        { params: filters }
      );

      console.log("SERVICE RAW RESPONSE:", response);
      return response;
    } catch (error) {
      console.error("Failed to fetch inventory items:", error);
      throw error;
    }
  },

  /** GET - Item by ID */
getById: async (id) => {
  try {
    const response = await apiClient.get(
      ENDPOINTS.INVENTORY_ITEMS.GET_BY_ID(id)
    );

    console.log("GET BY ID RAW RESPONSE:", response);
    return response;
  } catch (error) {
    console.error(`Failed to fetch item ${id}:`, error);
    throw error;
  }
},
  getSummary: async () => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.SUMMARY
      );
      return response.data;
    } catch (error) {
      console.error("Failed to fetch inventory summary:", error);
      throw error;
    }
  },

/** POST - Create new item */
  create: async (payload) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.INVENTORY_ITEMS.CREATE,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Failed to create inventory item:", error);
      throw error;
    }
  },

  /** PUT - Update item */
  update: async (id, payload) => {
    try {
      const response = await apiClient.put(
        ENDPOINTS.INVENTORY_ITEMS.UPDATE(id),
        payload
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to update inventory item ${id}:`, error);
      throw error;
    }
  },

  /** DELETE - Delete item */
  delete: async (id) => {
    try {
      const response = await apiClient.delete(
        ENDPOINTS.INVENTORY_ITEMS.DELETE(id)
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to delete inventory item ${id}:`, error);
      throw error;
    }
  },

  /** GET - Summary API */
getSummary: async () => {
  try {
    const response = await apiClient.get(
      ENDPOINTS.INVENTORY_ITEMS.SUMMARY
    );

    console.log("SUMMARY RAW RESPONSE:", response);

    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch inventory summary:", error);
    throw error;
  }
},

  /** GET - Low Stock Items */
  getLowStock: async () => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.LOW_STOCK
      );
      return response.data;
    } catch (error) {
      console.error("Failed to fetch low stock items:", error);
      throw error;
    }
  },

   // INVENTORY CATEGORY CRUD

  /** Categories: GET all */
getAllCategories: async (branchId) => {
  try {
    const params = {};
    if (branchId) params.branchId = branchId;
    const response = await apiClient.get(ENDPOINTS.INVENTORY_CATEGORY.GET_ALL, { params });

    if (Array.isArray(response.data)) {
      return response.data;
    }
    if (Array.isArray(response.data.data)) {
      return response.data.data;
    }

    return [];
  } catch (err) {
    console.error("Error fetching categories:", err);
    return [];
  }
},

  /** Categories: CREATE */
  createCategory: async (payload) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.INVENTORY_CATEGORY.CREATE,
        payload
      );
      return response.data.data;
    } catch (error) {
      console.error("Failed to create category:", error);
      throw error;
    }
  },

  /** Categories: UPDATE */
  updateCategory: async (id, payload) => {
    try {
      const response = await apiClient.put(
        ENDPOINTS.INVENTORY_CATEGORY.UPDATE(id),
        payload
      );
      return response.data.data;
    } catch (error) {
      console.error(`Failed to update category ${id}:`, error);
      throw error;
    }
  },

  /** Categories: DELETE */
  deleteCategory: async (id) => {
    try {
      const response = await apiClient.delete(
        ENDPOINTS.INVENTORY_CATEGORY.DELETE(id)
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to delete category ${id}:`, error);
      throw error;
    }
  },

  /** Categories: ACTIVATE */
  activateCategory: async (id) => {
    try {
      const response = await apiClient.put(
        ENDPOINTS.INVENTORY_CATEGORY.ACTIVATE(id)
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to activate category ${id}:`, error);
      throw error;
    }
  },

  /** Categories: DEACTIVATE */
  deactivateCategory: async (id) => {
    try {
      const response = await apiClient.put(
        ENDPOINTS.INVENTORY_CATEGORY.DEACTIVATE(id)
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to deactivate category ${id}:`, error);
      throw error;
    }
  },

  /** GET - Total inventory value */
  getTotalValue: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_STATS.TOTAL_VALUE, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch total inventory value:", error);
      throw error;
    }
  },

  /** GET - Total items count */
  getTotalItems: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_STATS.TOTAL_ITEMS, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch total items count:", error);
      throw error;
    }
  },

  /** GET - Out-of-stock count */
  getOutOfStockCount: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_STATS.OUT_OF_STOCK_COUNT, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch out-of-stock count:", error);
      throw error;
    }
  },

  /** GET - Low-stock count */
  getLowStockCount: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_STATS.LOW_STOCK_COUNT, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch low-stock count:", error);
      throw error;
    }
  },

  /** GET - Low Stock Items  */
  getLowStockItems: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.LOW_STOCK, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch low stock items:", error);
      throw error;
    }
  },

  /** GET - Out of Stock Items  */
  getOutOfStockItems: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.OUT_OF_STOCK, { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch out of stock items:", error);
      throw error;
    }
  },

  downloadTemplate: async () => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.DOWNLOAD_TEMPLATE,
        { responseType: 'blob' }
      );
      return response;
    } catch (error) {
      console.error("Failed to download template:", error);
      throw error;
    }
  },

  bulkUpload: async (file, action) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (action) {
        formData.append('action', action);
      }
      const response = await apiClient.post(
        ENDPOINTS.INVENTORY_ITEMS.BULK_UPLOAD,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to bulk upload inventory:", error);
      throw error;
    }
  },

  /** GET - List uploaded files filtered by action */
  getUploadedFiles: async (action) => {
    try {
      const params = {};
      if (action) params.action = action;
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.BULK_UPLOADS,
        { params }
      );
      return response.data ?? response;
    } catch (error) {
      console.error("Failed to fetch uploaded files:", error);
      throw error;
    }
  },

  /** GET - Download an uploaded file by ID */
  downloadUploadedFile: async (id) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.INVENTORY_ITEMS.BULK_DOWNLOAD(id),
        { responseType: 'blob' }
      );
      return response;
    } catch (error) {
      console.error("Failed to download uploaded file:", error);
      throw error;
    }
  },

  /** GET - Stock movement history for one item.
     *  params: { itemId, period, startDate?, endDate?, type?, offset, limit }
     *  'type' must be omitted (not sent) for All Types — the component
     *  already does that; axios also skips undefined params automatically. */
    getItemHistory: async (params) => {
      try {
        const response = await apiClient.get(
          ENDPOINTS.INVENTORY_ITEMS.ITEM_HISTORY,
          { params }
        );
        return response.data ?? response;
      } catch (error) {
        console.error("Failed to fetch item stock movement history:", error);
        throw error;
      }
    },

getStockConsumptionOverview({ period = 'DATE_RANGE', startDate, endDate } = {}) {
  const params = { period };
  if (startDate) params.startDate = startDate;
  if (endDate)   params.endDate = endDate;
  return apiClient.get(ENDPOINTS.STOCK.CONSUMPTION_OVERVIEW, { params });
  //     ▲ use this file's client name        ▲ ENDPOINTS confirmed from your config
}

};

export default inventoryitemService;
